{
  "field_required": "Ce champs est obligatoire",
  "title": "Titre",
  "number": "Numéro",
  "scene_submit": "Ajouter la scene"
}
